<template>
    <div class="col-lg-10 col-md-8 col-12 main">
        <Swiper :list="list" />
    </div>
</template>
<script>
import Swiper from "@/components/Swiper.vue";
export default {
    name: "home",
    components: {
        Swiper
    },
    data() {
        return {
            list: [
                { img: require("@/assets/resource/cats_stations/1.jpg"), alt: "123" },
                { img: require("@/assets/resource/cats_stations/2.jpg"), alt: "123" },
                { img: require("@/assets/resource/cats_stations/3.jpg"), alt: "123" },
                { img: require("@/assets/resource/cats_stations/4.jpg"), alt: "123" },
                { img: require("@/assets/resource/cats_stations/5.jpg"), alt: "123" },
                { img: require("@/assets/resource/cats_stations/6.jpg"), alt: "123" },
                { img: require("@/assets/resource/cats_stations/7.jpg"), alt: "123" },
            ],
        }
    },


};
</script>
<style scoped>
/* 
*{border:1px solid #000;} */

.main {
    height: 100vh;
    padding: 30px 15px;
}

@media (max-width: 768px) {
    .main {
        padding-top: 0px;
        height: calc(100vh - 90px);
    }

}
</style>
